export default __webpack_public_path__ + "static/media/goldenArrow.6632e32c.svg";